import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import TranslationKeys from 'src/constants/translation-keys';
import { IconQuestionCircleSmall } from '@amzn/stencil-react-icons';
import { recordEvent } from 'src/analytics/amplify'
import { RouterLink } from '../RouterLink';
import { Button, ButtonVariant } from '@amzn/stencil-react-components/button';
import { LinkTextDecorationOptions } from '@amzn/stencil-react-components/dist/submodules/link/interfaces';
import { token } from '@amzn/stencil-design-tokens/js/web/utils';

//TODO: Add flyout with FAQ content once content finalized
export default function FaqFlyout() {
    const { t } = useTranslation();

    useEffect(() => {
        recordEvent({
            name: 'FaqFlyout.Render',
            immediate: true
        });
    }, []);

    return (
        <RouterLink textDecoration={LinkTextDecorationOptions.None}
                data-testid="faq-flyout-button"
                to='/help#alumni'
                style={{textDecoration: 'none'}}>
            <Button variant={ButtonVariant.TertiaryInline}
                    as="span"
                    style={{color: token('color.link.primary-default')}}
                    icon={<IconQuestionCircleSmall aria-hidden={true} />}
                    data-testid="footer-text-faq">
                {t(TranslationKeys.UI.ALUMNI.HELP_FOOTER)}
            </Button>
        </RouterLink>
    );
}
